import { render, staticRenderFns } from "./scWpCountdownWidget.vue?vue&type=template&id=5b0ad040&scoped=true&"
import script from "./scWpCountdownWidget.vue?vue&type=script&lang=js&"
export * from "./scWpCountdownWidget.vue?vue&type=script&lang=js&"
import style0 from "./scWpCountdownWidget.vue?vue&type=style&index=0&id=5b0ad040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ad040",
  null
  
)

export default component.exports